import { observer } from 'mobx-react';
import { store } from '../Store';

import classNames from 'classnames';
import React from 'react';
import './LoadingOverlay.css';

import starLogo from '../assets/images/tcpt-star-logo.png';
import starLogoLarge from '../assets/images/tcpt-star-logo@2x.png';

import { Button } from './Button';

const LoadingOverlay = observer((props) => {

  const handleClickStart = () => {
    store.setStarted();
  };

  return (
    <div className={ classNames('loading', { 'visible' : props.visible }) }>
      <div className="starLogo">
        <img src={starLogo} srcSet={`${starLogo}, ${starLogoLarge} 2x`} alt="" />
      </div>

      <div className={classNames('percentage', { 'hidden': store.sceneLoaded })}>{store.loadingPercentage} %</div>

      <div className="copy">
        <h1 dangerouslySetInnerHTML={{ __html: props.content.home.title }} />

        <div dangerouslySetInnerHTML={{ __html: props.content.home.intro }} />

        <Button 
          onClick={handleClickStart} 
          enabled={store.sceneLoaded}
        >
          { props.content.home.button }
        </Button>
      </div>
    </div>
  )
});

export { LoadingOverlay };